import axios from 'axios';
import Vue from 'vue';
import { getToken } from '@/utils/storage';
import moment from 'moment-timezone';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000,
});

service.interceptors.request.use(
  (config) => {
    // 设置token
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 添加默认参数
    config.params = {
      ...config.params,
      time_zone: moment.tz.guess(),
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    // Some example codes here:
    // code == 200: success
    // code == 500: error
    const res = response.data;
    if (res.code !== 200) {
      Vue.prototype.$toast(res.message || 'Network error', {
        color: 'red',
        icon: 'fas fa-info-circle',
        timeout: 3000,
      });
      return Promise.reject(new Error(res.message || 'Error'));
    }
    return response.data;
  },
  (error) => {
    let errorMessage = '';
    if (error.code === 'ECONNABORTED') {
      errorMessage = 'Network timeout, Plase try again';
    } else {
      errorMessage = 'Network error';
    }
    Vue.prototype.$toast(errorMessage, {
      color: 'red',
      icon: 'fas fa-info-circle',
      timeout: 3000,
    });
    return Promise.reject(error);
  },
);

export default service;
